// SetupScreen.jsx
import React from 'react';
import ChatSetupFlow from './ChatSetupFlow';

export default function SetupScreen({ onSubmit, initialStep }) {
  return (
    <div className="p-6 overflow-y-auto">
      <ChatSetupFlow
        onSubmit={onSubmit}
        initialStepIndex={initialStep}
      />
    </div>
  );
}
